import React, {useState} from "react";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldTextArea from "../../../shared/controls/fieldTextArea";
import useApiEmpleados from "../../../api/catalogos/useApiEmpleados";
import FieldCalendar from "../../../shared/controls/fieldCalendar";
import moment from "moment";
import alerts from "../../../shared/alerts";
import FieldAutoComplete from "../../../shared/controls/fieldAutoComplete";

const BajaEmpleado = ({empleado, onBaja}) => {
    const [visibleModal, setVisibleModal] = useState(false);
    const [tipo, setTipo] = useState(null);
    const [causa, setCausa] = useState(null);
    const [fechaBaja, setFechaBaja] = useState(moment().startOf('day').toDate());
    const [comentarios, setComentarios] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [jefeInmediatoHistorial, setjefeInmediatoHistorial] = useState(empleado.asignacion?.jefeInmediato);
    const [reclutadorHistorial, setreclutadorHistorial] = useState(empleado.asignacion?.reclutador);
    const [gestorOperadoresHistorial, setgestorOperadoresHistorial]= useState(empleado.asignacion?.gestorOperadores);
    const [unidadNegocioHistorial, setunidadNegocioHistorial]= useState(empleado.asignacion?.unidadNegocio)
    const apiEmpleado = useApiEmpleados();

    const revisionMovs = async () => {
        setSubmitted(true);

        const [responseliquidacion, responseMovimientos, responseViajes] = await Promise.all([
            apiEmpleado.liquidacionPendientes(empleado.id),
            apiEmpleado.movimientosPendientes(empleado.id),
            apiEmpleado.viajesPendientes(empleado.id)
        ]);

        const tieneLiquidaciones = responseliquidacion.count > 0;
        const tieneMovimientos = responseMovimientos.count > 0;
        const tieneViajes = responseViajes.count > 0;

        if (!tieneLiquidaciones && !tieneMovimientos && !tieneViajes) {
           await baja();
            return;
        }
        let mensaje = '¿Está seguro de dar de baja al empleado? Tiene pendiente:\n';
        if (tieneLiquidaciones) mensaje += '• Pagos por dispersar.\n';
        if (tieneMovimientos) mensaje += '• Movimientos por liquidar.\n';
        if (tieneViajes) mensaje += '• Viajes por liquidar.\n';

        const confirmar = await alerts.preguntarSiNoAdvertencia(mensaje);
        if (!confirmar) return;
        if (tieneMovimientos) {
            await quitarMovimientos();
        }

        if (tieneViajes) {
            await quitarViajesPendientes();
        }

        await baja();
    };

    const baja = async () => {
        console.log('baja')
        setSubmitted(true);
        if ((tipo?.id ?? 0) === 0 || fechaBaja == null) {
            return;
        }
        await apiEmpleado.baja(empleado.id, {tipo, causa,comentarios, fechaBaja, jefeInmediatoHistorial, reclutadorHistorial, gestorOperadoresHistorial, unidadNegocioHistorial});
        await apiEmpleado.envioCorreo(empleado.id,{tipo, causa,comentarios, fechaBaja, alta:false});        
        setSubmitted(false);
        setVisibleModal(false);
        onBaja();
    };
    const quitarMovimientos = async () => {
        setSubmitted(true);        
        await apiEmpleado.rechazarMovimientos(empleado.id);
        onBaja();
    };
    const quitarViajesPendientes = async()=>{
        setSubmitted(true);        
        await apiEmpleado.rechazarViajes(empleado.id);
        onBaja();
    };
    const renderFooter = () => {
        return (
            <div>
                <Button label="No" icon="pi pi-times" onClick={() => setVisibleModal(false)} className="p-button-text"/>
                <Button label="Confirmar" icon="pi pi-check" onClick={revisionMovs} autoFocus/>
            </div>
        );
    };

    return (
        <>
            <Dialog header="¿Desea dar de baja al personal?" visible={visibleModal} style={{width: '40vw'}}
                    footer={renderFooter('displayBasic')} onHide={() => setVisibleModal(false)}>
                <div className="form-row" style={{overflow:'hidden'}}>
                    <FieldCalendar name="fechaBaja" label="Fecha" colMd={6} className="small"
                                   error={fechaBaja == null  && submitted} showButtonBar={false}
                                   filter
                                   value={fechaBaja}
                                   onChange={setFechaBaja}/>
                    <FieldDropDown name="tipo" label="Tipo de Baja" colMd={12} source="tipoBaja"
                                   error={(tipo?.id ?? 0) === 0 && submitted}
                                   scrollHeight={150}
                                   filter
                                   value={tipo}
                                   onChange={setTipo}/>
                    <FieldDropDown name="causa" label="Causa de Baja" colMd={12} source="causaBaja"
                                   error={(causa?.id ?? 0) === 0 && submitted}
                                   scrollHeight={150}
                                   filter
                                   value={causa}
                                   onChange={setCausa}/>          

                <FieldAutoComplete name="jefeInmediatoHistorial" label="Jefe Inmediato" colMd={12} source="empleados" 
                                    disabled={!!empleado.asignacion?.jefeInmediato} 
                                    value={jefeInmediatoHistorial}
                                    filter className="dropdown-bottom"
                                    params={{ todasLasEmpresas: true }} onChange={setjefeInmediatoHistorial} />
           
                <FieldAutoComplete name="reclutadorHistorial" label="Reclutador" colMd={12} source="empleados" 
                                   disabled={!!empleado.asignacion?.reclutador} 
                                   value={reclutadorHistorial}
                                   filter className="dropdown-bottom" onChange={setreclutadorHistorial}/>
                 <FieldAutoComplete name="gestorOperadoresHistorial" label="Gestor de operadores" colMd={12} source="empleados" 
                                    disabled={!!empleado.asignacion?.gestorOperadores} 
                                    value={gestorOperadoresHistorial}
                                    filter className="dropdown-bottom"
                                    params={{ todasLasEmpresas: true }} onChange={setgestorOperadoresHistorial} />
                 <FieldDropDown name="unidadNegocioHistorial" label="Unidad de Negocio" colMd={12} source="unidadesNegocio" 
                                    disabled={!!empleado.asignacion?.unidadNegocio} 
                                    value={unidadNegocioHistorial}
                                    filter className="dropdown-bottom"
                                    onChange={setunidadNegocioHistorial} />

                <FieldTextArea name="comentarios" label="Comentarios" colMd={12} rows={6}
                                   value={comentarios} onChange={setComentarios}/>

                </div>
            </Dialog>

            <Button label="Dar de Baja" className="p-button-outlined p-button-danger" type="button"
                    onClick={() => setVisibleModal(true)}/>
        </>
    )
};

export default BajaEmpleado;
